import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, Input, Link, Modal, Multiselect, Pagination, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneTakeoff, mdiArrowExpandLeft, mdiArrowExpandRight, mdiBagChecked, mdiCloseBox, mdiDoor, mdiDotsVerticalCircle, mdiLock } from '@mdi/js';
import Icon from '@mdi/react';
import ReactJsonView from '@microlink/react-json-view';
import DRPickerModal from '../../../../components/DRPicker';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import SelectAirline from '../../../../components/selects/SelectAirline';
import SelectAirport from '../../../../components/selects/SelectAirport';
import SelectBelt from '../../../../components/selects/SelectBelt';
import SelectGate from '../../../../components/selects/SelectGate';
import SelectPaging from '../../../../components/selects/selectPaging';
import SelectStatus from '../../../../components/selects/SelectStatus';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getAirline, getAirport, getBelt, getCookie, getGate, getStatus, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';

export const FlightsSearchPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const { navigate } = useRouter();
    const { parameters, menu, data, idAirport } = useGlobalState();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [jsonRMS, setJsonRMS] = useState<any[]>([])
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const filtered: ItemFlight[] = flights.filter((item) => {

        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.flightNumber.toString(), item.idFlightAODB.toString(), item.idFlight.toString(),
        item.destination, item.origin, item.airline, item.status, item.destinationAirport, item.originAirport, item.gate, item.belt,
        item.arrivalTime, item.departureTime, item.arrivalTimeReal, item.departureTimeReal
        ].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);



    const handleSearchFlights = async () => { // Make the function async
        try {
            setLoading(true)
            let body = {}
            if (parameters.start) body = { ...body, start: parameters.start }
            if (parameters.end) body = { ...body, end: parameters.end }
            if (parameters.idAirportsOrigin) body = { ...body, idAirportsOrigin: parameters.idAirportsOrigin }
            if (parameters.idAirportsDestination) body = { ...body, idAirportsDestination: parameters.idAirportsDestination }
            if (parameters.idAirlines) body = { ...body, idAirlines: parameters.idAirlines }
            if (parameters.idGates) body = { ...body, idGates: parameters.idGates }
            if (parameters.idBelts) body = { ...body, idBelts: parameters.idBelts }
            if (parameters.idStatuses) body = { ...body, idStatuses: parameters.idStatuses }
            if (parameters.sources) body = { ...body, sources: parameters.sources }
            body = { ...body, timeOrder: "ASC" }
            body = { ...body, limit: 10000 }
            console.log(body)

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/list',
                },
                body: JSON.stringify(body),
            });
            console.log("TEST")

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            console.log("TEST2")
            if (dataWeb.code == 0) {
                const dataMap = dataWeb.flights.map((flight: ItemFlight) => ({
                    ...flight,
                    origin: getAirport(flight.idAirportOrigin, data)?.city || 'NC',
                    destination: getAirport(flight.idAirportDestination, data)?.city || 'NC',
                    originAirport: getAirport(flight.idAirportOrigin, data)?.IATA || 'NC',
                    destinationAirport: getAirport(flight.idAirportDestination, data)?.IATA || 'NC',
                    airline: getAirline(flight.idAirline, data)?.shortNameAirline || 'NC',
                    status: getStatus(flight.idStatus, data)?.statusES || 'N/D',
                    gate: getGate(flight.idGate, data)?.gate || '',
                    belt: getBelt(flight.idBelt, data)?.belt || '',
                    direction: flight.idAirportOrigin === flight.idAirportOwner ? 'OUT' : 'IN',
                }));

                setFlights(dataMap);
                setCurrentPageIndex(1);

            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {

    }, []);

    const sources = [{ label: "Vía manual", value: "MANUAL" }, { label: "Vía RMS", value: "RMS" }];
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s" direction='vertical'>
                    <Header variant="h1" actions={<Favorites />}>Búsqueda de vuelos</Header>
                    <SpaceBetween size="m" direction="horizontal">
                        <FormField label="Origenes">
                            <SelectAirport hideTokens single={false} value={parameters.idAirportsOrigin || []} onSelect={(airports) => {
                                setParameters({
                                    ...parameters, idAirportsOrigin: airports
                                })
                            }} />
                        </FormField>
                        <FormField label="Destinos">
                            <SelectAirport hideTokens single={false} value={parameters.idAirportsDestination || []} onSelect={(airports) => {
                                setParameters({
                                    ...parameters, idAirportsDestination: airports
                                })
                            }} />
                        </FormField>
                        <FormField label="Aerolineas">
                            <SelectAirline hideTokens single={false} value={parameters.idAirlines || []} onSelect={(airlines) => {
                                setParameters({
                                    ...parameters, idAirlines: airlines
                                })
                            }} />
                        </FormField>
                        <FormField label="Puertas">
                            <SelectGate hideTokens single={false} value={parameters.idGates || []} onSelect={(gates) => {
                                setParameters({
                                    ...parameters, idGates: gates
                                })
                            }} />
                        </FormField>
                        <FormField label="Cintas">
                            <SelectBelt hideTokens single={false} value={parameters.idBelts || []} onSelect={(belts) => {
                                setParameters({
                                    ...parameters, idBelts: belts
                                })
                            }} />
                        </FormField>
                        <FormField label="Estados">
                            <SelectStatus hideTokens single={false} value={parameters.idStatuses || []} onSelect={(statuses) => {
                                setParameters({
                                    ...parameters, idStatuses: statuses
                                })
                            }} />
                        </FormField>
                        <FormField label="Fuente">
                            {sources && (
                                <Multiselect
                                    hideTokens
                                    placeholder={
                                        // Added ?. after sources
                                        !parameters?.sources || parameters.sources.length === 0
                                            ? "Seleccionar fuentes"
                                            : `${parameters.sources.length}/2 seleccionadas`
                                    }
                                    selectedOptions={sources.filter(option => parameters.sources?.includes(option.value))}
                                    options={sources}
                                    onChange={({ detail }) => {
                                        const list = detail.selectedOptions as { label: string; value: string }[];
                                        const selectedValues = list.map(item => item.value); // Extract array of values
                                        setParameters({
                                            ...parameters, sources: selectedValues
                                        })
                                    }}
                                />
                            )}
                        </FormField>
                        <FormField label="Rango de fechas">
                            <DRPickerModal start={parameters.start} end={parameters.end}
                                onConfirm={(start, end) => {

                                    if (start)
                                        setParameters({
                                            ...parameters, start: start, end: end
                                        })
                                }}
                            />
                        </FormField>

                    </SpaceBetween>
                    <Button onClick={() => { handleSearchFlights() }}>Buscar vuelos</Button>

                    <Table

                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > parameters.pageSize && (

                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        variant='embedded'
                        stickyHeader
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Palabra(s) clave(s)">
                                    <Input value={filterValue} placeholder="Buscar vuelos" onChange={e => setFilterValue(e.detail.value)} />
                                </FormField>
                            </SpaceBetween>
                        }
                        items={paginated ?? []}
                        empty={
                            <Box
                                margin={{ vertical: "xs" }}
                                textAlign="center"
                                color="inherit"
                            >
                                <SpaceBetween size="m">
                                    <b>Sin vuelos en la fecha seleccionada</b>
                                </SpaceBetween>
                            </Box>
                        }
                        cellVerticalAlign='top'
                        contentDensity='compact'
                        wrapLines={false}
                        columnDefinitions={[
                            {

                                id: 'idFlight',
                                header: 'ID',
                                cell: (item) => <FormField label={<Link href={`#flights/edit?id=${item.idFlight}`}>{item.idFlight}</Link>} info={item.isActive === 1 ? "" :
                                    <Icon path={mdiCloseBox} size={0.75} color={"red"} />}>
                                    {item.idFlightAODB > 0 ? item.jsonRMS.length > 0 ? <>RMS {item.idFlightAODB} <Link onClick={() => { setJsonRMS(item.jsonRMS) }}><Icon path={mdiDotsVerticalCircle} size={0.75} />
                                    </Link></> : <>{`RMS ${item.idFlightAODB}`}</> : ''}
                                </FormField>,
                                minWidth: 70,
                            },
                            {
                                id: 'direction',
                                header: '',
                                cell: (item) => item.direction === 'OUT' ? <Icon path={mdiAirplaneTakeoff} size={1} /> : <Icon path={mdiAirplaneLanding} size={1} />,
                                width: 40,
                            },
                            {
                                id: 'origin2',
                                header: <Icon path={mdiAirplaneTakeoff} size={1} />,
                                cell: (item) => item.idAirportOrigin === idAirport ? <strong>{item.originAirport}</strong> : item.originAirport,
                                width: 40,
                            },
                            {
                                id: 'destination2',
                                header: <Icon path={mdiAirplaneLanding} size={1} />,
                                cell: (item) => item.idAirportDestination === idAirport ? <strong>{item.destinationAirport}</strong> : item.destinationAirport,
                                width: 40,
                            },
                            {
                                id: 'flightNumber',
                                header: 'Vuelo',
                                cell: (item) => <FormField label={`${item.airline}-${item.flightNumber}`} >
                                    {item.direction === 'IN' ? <><Icon path={mdiBagChecked} size={0.75} /> {item.belt}</> : <><Icon path={mdiDoor} size={0.75} /> {item.gate}</>}
                                    {item.isClosed === 1 ? <> |  <Icon path={mdiLock} size={0.75} /></> : null}

                                </FormField>,
                                minWidth: 130,
                            },
                            {
                                id: 'boarding',
                                header: "Embarque",
                                cell: (item) => <FormField label={item.direction === 'OUT' ? item.boardingTime : ""}
                                    info={
                                        item.direction === 'OUT' ?
                                            item.boardingDelta !== 0 ?
                                                <Icon path={item.boardingDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /> :
                                                "" :
                                            ""
                                    }
                                >
                                    {item.direction === 'OUT' ? item.boardingTime : ""}

                                </FormField>,
                                minWidth: 100,
                                width: 100,
                            },
                            {
                                id: 'schedule',
                                header: "Horario",
                                cell: (item) => <FormField label={item.direction === 'OUT' ?
                                    item.departureTimeReal
                                    :
                                    item.arrivalTimeReal}
                                    info={
                                        item.direction === 'OUT' ?
                                            item.departureDelta !== 0 ?
                                                <BadgeCustom color={item.departureDelta > 0 ? "lime" : "red"} size="xsmall" padding={0.1}><Icon path={item.departureDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /></BadgeCustom> :
                                                "" :
                                            item.arrivalDelta !== 0 ?
                                                <BadgeCustom color={item.arrivalDelta > 0 ? "lime" : "red"} padding={0.1}><Icon path={item.arrivalDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /></BadgeCustom> :
                                                ""


                                    }
                                >
                                    {item.direction === 'OUT' ? item.departureTime : item.arrivalTime}

                                </FormField>,
                                minWidth: 100,
                                width: 120,
                            },
                            {
                                id: 'status',
                                header: 'Estado',
                                cell: (item) => <><Box color="text-body-secondary">{item.status}</Box> </>,
                            },
                        ]}
                    />


                    <Modal visible={jsonRMS.length > 0} onDismiss={() => setJsonRMS([])} header="Datos RMS" footer={<Button variant="link" onClick={() => setJsonRMS([])}>Cerrar</Button>}>

                        <ReactJsonView src={jsonRMS}
                            name={false}
                            style={{ minHeight: 300 }}
                            collapsed={1}
                            collapseStringsAfterLength={50}
                            displayObjectSize={true}
                            displayDataTypes={true}
                            enableClipboard={true}
                        />
                    </Modal>
                </SpaceBetween>
            }
        />
    )
};
